module.exports = __webpack_public_path__ + "img/5t.e2558a5b.jpg";